export default __webpack_public_path__ + "static/media/apple.b291f04d.png";